import '../../sass/Frontpage.scss'

const elements = document.getElementsByClassName('Frontpage--Hero')
let autoAnimateHeroInterval = undefined
let progressInterval = undefined

const showProgress = (progressBar, duration) => {
    if (progressInterval) {
        clearInterval(progressInterval)
        progressInterval = undefined
    }

    if (progressBar) {
        let progressStep = 0
        const dividingPoint = Math.floor(duration / 150)
        progressInterval = setInterval(() => {
            if (dividingPoint > progressStep) {
                ++progressStep;
                requestAnimationFrame(() => {
                    const percentage = Math.abs(Math.round((progressStep / dividingPoint) * 10000) / 10000);
                    progressBar.style.transform = `scaleX(${percentage})`;
                })
            }
        }, 150)
    }
}

const autoAnimateHero = (element) => {
    if (autoAnimateHeroInterval) {
        clearInterval(autoAnimateHeroInterval)
        autoAnimateHeroInterval = undefined
    }

    let duration = 5000
    const dataDuration = parseInt(element.dataset?.duration ?? '')
    if (!isNaN(dataDuration))
        duration = parseInt(element.dataset.duration)

    const progressBar = element.getElementsByClassName('Progress')?.[0]
    autoAnimateHeroInterval = setInterval(() => {
        handleHeroClick(element)()

        showProgress(progressBar, duration)
    }, element.dataset.duration ?? duration)
    showProgress(progressBar, duration)
}

const handleHeroClick = (element) => {
    return () => {
        clearInterval(autoAnimateHeroInterval)
        autoAnimateHeroInterval = undefined

        const BgWrap = element.getElementsByClassName('BgWrap')?.[0]
        const ScaleWrap = element.getElementsByClassName('Scales')?.[0]
        const TextElements = element.getElementsByClassName('Text')?.[0]?.children ?? []
        let NextTextElement = null
        let CurrentTextElement = null

        let index = 0
        let useNextElement = false
        for (let TextElement of TextElements) {
            ++index

            if (!NextTextElement) {
                NextTextElement = TextElement
            }

            /*if (!CurrentTextElement) {
                CurrentTextElement = TextElement
            }*/

            if (useNextElement) {
                NextTextElement = TextElement
                break
            }

            if (TextElement.classList.contains('Active')) {
                CurrentTextElement = TextElement
                useNextElement = true
            }
        }

        let SVGScaleLeft = null
        let SVGScaleRight = null
        let TheLine = null

        let ScalesSvg = null
        if (ScaleWrap) {
            ScalesSvg = ScaleWrap.getElementsByTagName('svg')?.[0]

            if (ScalesSvg) {
                SVGScaleLeft = ScalesSvg.getElementsByClassName('scale_left')?.[0]
                TheLine = ScalesSvg.getElementsByClassName('the_line')?.[0]
                SVGScaleRight = ScalesSvg.getElementsByClassName('scale_right')?.[0]
            }
        }

        const hasScales = !!(ScalesSvg && SVGScaleLeft && TheLine && SVGScaleRight)
        if (NextTextElement && CurrentTextElement !== NextTextElement) {
            if (NextTextElement.classList.contains('Right')) {
                BgWrap.classList.remove('Left')
                BgWrap.classList.add('Right')

                if (hasScales) {
                    SVGScaleLeft.setAttribute('transform', 'translate(0, 0)')
                    TheLine.setAttribute('d', 'M662.6 0.400766C655.6 2.30077 651.5 9.40077 653.4 16.3008C653.8 17.7008 654.5 19.1008 655.3 20.3008C646.7 25.7008 633.8 32.7008 620.4 35.8008C571.1 47.2008 523.7 29.6008 478.3 41.8008C422.8 56.7008 402 97.2008 402 97.2008C402 97.2008 363.7 72.5008 308.2 87.4008C262.8 99.6008 230.5 138.501 182.2 153.301C169.1 157.301 154.4 157.701 144.3 157.401C144.4 155.901 144.3 154.501 143.9 152.901C142 145.901 134.9 141.801 128 143.701C121 145.601 116.9 152.701 118.8 159.601C120.7 166.601 127.8 170.701 134.7 168.801C139 167.601 142.2 164.401 143.7 160.501C153.5 163.001 168.4 164.901 185.7 160.601C237.7 148.001 264.1 116.801 313.3 103.601C344.1 95.3008 378.1 107.401 396.1 115.601C404 119.201 407 115.301 407 115.301C407 115.301 411.7 116.901 417 109.601C428.5 93.5008 451.7 66.5008 482.3 58.4008C531.5 45.2008 570 59.0008 621.3 43.9008C638.3 38.9008 650.3 29.8008 657.6 22.8008C660.7 25.5008 665.2 26.7008 669.5 25.5008C676.5 23.6008 680.6 16.5008 678.7 9.60077C676.6 2.60077 669.4 -1.39923 662.6 0.400766Z')
                    ScalesSvg.classList.add('Right')
                    SVGScaleRight.setAttribute('transform', 'translate(0, 0)')
                }
            } else {
                BgWrap.classList.add('Left')
                BgWrap.classList.remove('Right')

                if (hasScales) {
                    SVGScaleLeft.setAttribute('transform', 'translate(0, -143.3)')
                    TheLine.setAttribute('d', 'M669.361 143.602C662.349 141.748 655.248 145.847 653.444 152.772C653.091 154.185 652.997 155.747 653.09 157.186C642.942 157.563 628.27 157.176 615.115 153.161C566.72 138.385 534.469 99.4444 489.051 87.3115C433.536 72.4671 395.273 97.1425 395.273 97.1425C395.273 97.1425 374.453 56.6024 318.938 41.758C273.52 29.6251 226.098 47.1651 176.869 35.8339C163.524 32.7485 150.593 25.7453 141.996 20.4358C142.833 19.1867 143.446 17.9243 143.9 16.3386C145.754 9.32639 141.655 2.22583 134.729 0.421512C127.717 -1.4328 120.616 2.66623 118.812 9.59187C116.958 16.6041 121.057 23.7047 127.982 25.509C132.306 26.6196 136.678 25.4482 139.927 22.8206C147.164 29.8854 159.118 38.9804 176.25 43.9059C227.584 58.9923 266.047 45.171 315.256 58.3377C346.08 66.5487 369.475 94.0268 380.964 110.128C386.006 117.195 390.554 115.318 390.554 115.318C390.554 115.318 393.825 119.053 402.064 115.381C420.073 107.187 453.665 95.4035 484.215 103.688C533.424 116.854 559.867 148.055 611.845 160.626C629.068 164.795 644.01 162.914 653.832 160.501C655.166 164.39 658.464 167.679 662.788 168.789C669.8 170.644 676.9 166.545 678.705 159.619C680.386 152.507 676.15 145.443 669.361 143.602Z')
                    ScalesSvg.classList.remove('Right')
                    SVGScaleRight.setAttribute('transform', 'translate(0, 143.3)')
                }
            }

            if (CurrentTextElement)
                CurrentTextElement.classList.remove('Active')

            NextTextElement.classList.add('Active')
        }

        autoAnimateHero(element)
    }
}

for (let element of elements) {
    element.addEventListener('click', handleHeroClick(element), {passive: true})

    if (element.dataset.animateFirst === 'true') {
        // Animate in first slide
        setTimeout(() => {
            handleHeroClick(element)()
        }, 150)
    } else {
        autoAnimateHero(element)
    }
}
